import { mainApi } from "../services/main/api";
import { IArtifactDetails } from "./getArtifactDetailsById";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        updateArtifactDetailsById: builder.mutation<
            UpdateArtifactDetailsByIdResponse,
            UpdateArtifactDetailsByIdRequest
        >({
            query: (request?: UpdateArtifactDetailsByIdRequest) => ({
                url: "updateArtifactDetailsById",
                body: request,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useUpdateArtifactDetailsByIdMutation } = extendedApi;

export interface UpdateArtifactDetailsByIdRequest {
    artifactType: string;
    artifactId: string;
    businessUseCase: string;
    clientName: string;
    updatedBy: string;
    updatedArtifactDetails: IArtifactDetails;
}

export interface UpdateArtifactDetailsByIdResponse {
    status: string;
}
